module.exports = __webpack_public_path__ + "img/certified.54c795a9.svg";